import React from 'react';
import Moment from 'react-moment';
import moment from 'moment';
import {
  Card,
  CardHeader,
  CardContent,
  CardFooter,
} from '@/components/ui/card';
import { Heading } from '@/components/ui/shared/heading';
import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';

export const VisitInstrumentalResearchesDetails = ({
  instrumentalResearches,
  instrumentalResearchesRef,
  handleFileDownload,
}) => {
      console.log("VisitInstrumentalResearchesDetails")

  if (
    !Array.isArray(instrumentalResearches) ||
    instrumentalResearches.length === 0
  )
    return null;

  return (
    <div ref={instrumentalResearchesRef}>
      {instrumentalResearches.map((research, index) => (
        <Card key={index} className="mb-4">
          <CardHeader>
            <Heading variant="userAccountDetailsTitle">
              Instrumentinis tyrimas
            </Heading>
          </CardHeader>
          <CardContent className="space-y-4">
            <div>
              <span>Data: </span>
              <span>
                {new Date(Date.parse(research.date)).getUTCHours() === 0 ? (
                  <Moment utc format="YYYY-MM-DD">
                    {Date.parse(research.date)}
                  </Moment>
                ) : (
                  <Moment utc format="YYYY-MM-DD HH:mm">
                    {Date.parse(research.date)}
                  </Moment>
                )}
              </span>
            </div>

            <div>
              <span>Pavadinimas: </span>
              <span>{research.name}</span>
            </div>

            <div>
              <span>Įranga: </span>
              <span>{research.device}</span>
            </div>

            <div className="mt-2 font-medium">
              <span>Instrumentinio tyrimo kontrastas: </span>
              {research.instrumentalResearchContrast ? (
                <>
                  <span>
                    <span>Pavadinimas: </span>
                    <span>{research.contrast.name}</span>
                  </span>
                  <span>
                    <span>Tipas: </span>
                    <span>{research.contrast.type}</span>
                  </span>
                  <span>
                    <span>Serijinis numeris: </span>
                    <span>{research.contrast.serialNumber}</span>
                  </span>
                  <span>
                    <span>Kiekis: </span>
                    <span>{research.contrast.value}</span>
                  </span>
                  <span>
                    <span>Matavimo vienetas: </span>
                    <span>{research.contrast.unit}</span>
                  </span>
                </>
              ) : (
                <span>Netaikytas</span>
              )}
            </div>

            {research.observations?.length > 0 &&
              research.observations.map((obs, idx) => (
                <div key={idx} className="border-t pt-4 mt-4 space-y-3">
                  <div className="font-medium">
                    Instrumentinių tyrimų vertinimai:
                  </div>

                  <div>
                    <span>Data: </span>
                    <span>
                      {new Date(Date.parse(obs.date)).getUTCHours() === 0 ? (
                        <Moment utc format="YYYY-MM-DD">
                          {Date.parse(obs.date)}
                        </Moment>
                      ) : (
                        <Moment utc format="YYYY-MM-DD HH:mm">
                          {Date.parse(obs.date)}
                        </Moment>
                      )}
                    </span>
                  </div>

                  <div>
                    <span>Dokumento numeris: </span>
                    <span>{obs.documentNumber}</span>
                  </div>

                  <div>
                    <span>Radiologo vardas: </span>
                    <span>{obs.radiologist.name}</span>
                  </div>

                  <div>
                    <span>Radiologo pavardė: </span>
                    <span>{obs.radiologist.surname}</span>
                  </div>

                  <div>
                    <span>Radiologo technologo vardas: </span>
                    <span>{obs.radiologyTechnologist.name}</span>
                  </div>

                  <div>
                    <span>Radiologo technologo pavardė: </span>
                    <span>{obs.radiologyTechnologist.surname}</span>
                  </div>

                  <div>
                    <span>Išvados: </span>
                    <span>{obs.value}</span>
                  </div>

                  <div>
                    <span>Aprašymas: </span>
                    <span>{obs.description}</span>
                  </div>

                  {obs.file?.guid && (
                    <div>
                      <Button
                        variant="light"
                        onClick={() => {
                          const fileName = `Instrumentinis tyrimas ${
                            obs.documentNumber
                          } ${moment(new Date(obs.date)).format('YYYY-MM-DD')}`;
                          handleFileDownload(
                            'InstrumentalResearches',
                            fileName,
                            obs.file.type,
                            obs.file.guid,
                          );
                        }}
                      >
                        <Download />
                        Atsisiųsti PDF
                      </Button>
                    </div>
                  )}
                </div>
              ))}
          </CardContent>
          <CardFooter />
        </Card>
      ))}
    </div>
  );
};
